import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import ProjectsList from './ProjectsList';
import { Button } from 'reactstrap';
import AddProjectModel from './AddProjectModel';
import { useDispatch, useSelector } from 'react-redux';

const ProjectTab = () => {
  // State to manage modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const projList = useSelector((state) => state?.Webtracker?.projects);

  // Function to toggle the modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-2"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Button className="" size="sm" color="dark" onClick={toggleModal}>
              + Create Project
            </Button>
            {/* <select className="col-1 form-control btn-sm">
              <option>Actions</option>
            </select> */}
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card m-b-20">
                <div className="card-body">
                  <div className="d-flex justify-content-end">
                    {/* Button to open the modal */}
                  </div>

                  {/* AddProjectModel modal component */}
                  <AddProjectModel open={isModalOpen} onClose={toggleModal} />

                  <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-toggle="tab"
                        href="#home1"
                        role="tab"
                      >
                        <span className="d-none d-md-block">
                          Projects {projList?.count}
                        </span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-home-variant h5"></i>
                        </span>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a className="nav-link" data-toggle="tab" href="#profile2" role="tab">
                        <span className="d-none d-md-block">Archive</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li> */}
                  </ul>

                  <div className="tab-content">
                    <div className="tab-pane active" id="home1" role="tabpanel">
                      <ProjectsList data={projList?.rows} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default ProjectTab;
